module.exports = __webpack_public_path__ + "static/media/products-no-image.379bdc70.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/img/no-images/products-no-image.jpg
// module id = 957
// module chunks = 0